import axios from 'axios';

// ─── API bāzes URL ───────────────────────────────────────────────────────────
// Prod:  REACT_APP_API_URL=https://api.tavs-domens.lv/api (no client/.env.production)
// Dev:   REACT_APP_API_URL=http://localhost:5000/api     (no client/.env.development vai default)
export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Serveri mapes URL — logos un citiem statiskiem assetiem, kas atrodas nevis /api/... bet /uploads/...
// Atvasinām no API_BASE, noņemot trailing "/api".
export const SERVER_BASE = API_BASE.replace(/\/api\/?$/, '');

// withCredentials sends the HttpOnly auth cookie on every request (incl. cross-origin dev port)
const api = axios.create({ baseURL: API_BASE, withCredentials: true });

// Auto-logout when the session cookie has expired or been invalidated
api.interceptors.response.use(
  response => response,
  error => {
    const status = error.response?.status;
    const msg = error.response?.data?.message || '';
    const isAuthError =
      status === 401 ||
      (status === 403 && /invalid token|access token required/i.test(msg));

    if (isAuthError) {
      localStorage.removeItem('user');
      localStorage.removeItem('currentCompanyId');
      // /oauth/authorize apzināti izsauc authorize-info BEZ sesijas, lai
      // noskaidrotu, vai jārāda login — 401 tur ir gaidīts stāvoklis, ne
      // sesijas beigas, tāpēc nedrīkst trigerēt reload (bezgalīga cilpa).
      const exempt = window.location.pathname === '/login' ||
                     window.location.pathname === '/oauth/authorize';
      if (!exempt) {
        window.location.reload();
      }
    }
    return Promise.reject(error);
  }
);

export default api;
